<template>
  <div class="vertical-nav-menu-group">
    <div
      v-if="!menuIsVerticalNavMini || (menuIsVerticalNavMini && isMouseHovered)"
      class="vertical-nav-menu-group__title">
      <div class="before-border"></div>
      <span>
        {{ $t(item.title) }}
      </span>
      <div class="after-border"></div>
    </div>
    <div v-else class="vertical-minimised-divider-with-title"></div>

    <component
      :is="resolveNavItemComponent(child)"
      v-for="child in item.children"
      :key="child.subheader || child.title"
      :item="child"></component>

    <div v-if="!item.hideBottomBar">
      <div
        v-if="!menuIsVerticalNavMini || (menuIsVerticalNavMini && isMouseHovered)"
        class="vertical-nav-menu-group__divider"></div>

      <div v-else class="vertical-nav-menu-group__divider vertical-minimised-divider"></div>
    </div>
  </div>
</template>

<script>
  // SFCs
  import VerticalNavMenuSectionTitle from "@core/layouts/components/vertical-nav-menu/components/vertical-nav-menu-section-title/VerticalNavMenuSectionTitle.vue";
  import VerticalNavMenuLink from "@core/layouts/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue";
  import useVerticalNavMenu from "@/@core/layouts/composable/vertical-nav/useVerticalNavMenu";
  // Composable
  import useAppConfig from "@core/@app-config/useAppConfig";
  import { inject } from "@vue/composition-api";
  export default {
    name: "VerticalNavMenuGroup",
    components: {
      VerticalNavMenuLink,
      VerticalNavMenuSectionTitle,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    setup() {
      const { resolveNavItemComponent } = useVerticalNavMenu();
      const { menuIsVerticalNavMini } = useAppConfig();
      const isMouseHovered = inject("isMouseHovered");

      return {
        resolveNavItemComponent,
        menuIsVerticalNavMini,
        isMouseHovered,
      };
    },
  };
</script>

<style lang="scss">
  @import "../../../../../preset/preset/typography/index";
  @import "../../../../../preset/preset/functions";

  .vertical-nav-menu-group {
    &__title {
      @include text-caption-bold();
      color: get-color("same-menu-text") !important;
      text-transform: uppercase;
      padding: 12px 0px;
      white-space: nowrap;
      position: relative;
      display: flex;
      align-items: center;

      .before-border {
        border-top: 1px solid get-color("same-divider") !important;
        flex-grow: 1;
        margin-right: 10px;
      }

      .after-border {
        border-top: 1px solid get-color("same-divider") !important;
        flex-grow: 10;
        margin-left: 14px;
      }
    }

    &__divider {
      margin: 12px 0 0 12px;
      border-bottom: 1px solid get-color("same-divider");
    }
  }

  .vertical-minimised-divider {
    margin: 12px 6px 0 12px;
  }

  .vertical-minimised-divider-with-title {
    border-bottom: 1px solid var(--v-same-divider-base);
    margin: 19.5px 6px 31.5px 12px;
  }
</style>
